// extracted by mini-css-extract-plugin
export var button = "searchSKU-module--button--13aV1";
export var input = "searchSKU-module--input--JdB1U";